export default __webpack_public_path__ + "static/media/down-arrows.1d965172.svg";